import { Component, Input, OnInit, TemplateRef } from '@angular/core';

@Component({
    standalone: false,
    selector: 'crm-permission-wrapper',
    template: `
    <div class="wrapper-container" matTooltip="You don't have required permissions, Please contact your System Administrator in order to request permissions">
        <div class="wrapper"></div>
        <div (keydown)="preventActions($event)">
            <ng-container *ngTemplateOutlet="template"></ng-container>
        </div>
    </div>
    `,
    styles: [
        `
            .wrapper-container {
                cursor: not-allowed;
                position: relative;
                opacity: 0.4;
            }
            ::ng-deep .wrapper-container * {
                pointer-events: none;
            }
            .wrapper{
                position: absolute;
                width: 100%;
                height: 100%;
            }
        `
    ]
})

export class PermissionWrapperComponent implements OnInit {
    @Input() template: TemplateRef<any> | null = null;

    constructor() { }

    ngOnInit() { }

    preventActions(event: Event): void {
        event.stopPropagation()
        event.preventDefault();
        return
    }
}
